<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-input v-model="filter" filled label="جستجو" />
      <q-table
          flat
          :data="items"
          row-key="index"
          :rows-per-page-options="[100]"
          :filter="filter">
        <template v-slot:header>
          <q-tr class="bg-indigo-10 text-white text-center">
            <td style="width: 100px"></td>
            <td class="text-white text-subtitle2">نام و نام خانوادگی</td>
            <td class="text-white text-subtitle2">شماره تماس</td>
            <td class="text-white text-subtitle2">شماره پلاک</td>
            <td class="text-white text-subtitle2">نوع خودرو</td>
            <td class="text-white text-subtitle2">مدل خودرو</td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <td style="width: 100px">
              <q-btn flat icon="edit" round color="indigo" @click="editData(props.row)">
                <q-tooltip>
                  ویرایش
                </q-tooltip>
              </q-btn>
            </td>
            <td class="text-center">{{ props.row.Visitor_Name }}</td>
            <td class="text-center">{{ props.row.Visitor_Tel }}</td>
            <td class="text-center" dir="ltr">{{ props.row.Visitor_NumCar }}</td>
            <td class="text-center">{{props.row.VisitorCarType}}</td>
            <td class="text-center">{{ props.row.VisitorCarModel}}</td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog v-model="driverInfoDialog">
      <DriverInfo :driver-info="localDriverInfo"
                  @driver-added="$emit('driver-updated', localDriverInfo); driverInfoDialog=false"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import DriverInfo from "@/components/Driver/DriverInfo";

export default {
  name: "DriverItems",
  components: {DriverInfo},
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      driverInfoDialog: false,
      filter: undefined,
      localDriverInfo: {
        Visitor_Name: '',
        Visitor_Tel: '',
        Visitor_NumCar: ''
      }
    }
  },
  methods: {
    ...mapActions({}),
    editData(row) {
      this.localDriverInfo.Visitor_NumCar = row.Visitor_NumCar
      this.localDriverInfo.Visitor_Name = row.Visitor_Name
      this.localDriverInfo.Visitor_Tel = row.Visitor_Tel
      this.driverInfoDialog = true
    },
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 0;
  z-index: 1000
}
</style>